import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      // TOP画面
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      // 購入履歴画面
      path: '/purchases',
      name: 'purchases',
      component: () => import('./views/PurchasesList.vue')
    },
    {
      // ユーザー登録画面
      path: '/regist',
      name: 'regist',
      component: () => import('./views/Regist.vue')
    },
    {
      // 店舗一覧画面
      path: '/stores',
      name: 'stores',
      component: () => import('./views/StoresList.vue')
    },
    {
      // おすすめ一覧画面
      path: '/recomendation',
      name: 'recomendation',
      component: () => import('./views/RecomendationList.vue')
    },
    {
      // モバイルオーダー画面（リアレジ）起動画面
      path: '/mobileorder',
      name: 'mobileorder',
      component: () => import('./views/MobileOrder.vue')
    },
    {
      // ユーザー登録待機画面
      path: '/bridge',
      name: 'bridge',
      component: () => import('./views/Bridge.vue')
    },
    {
      // エラー画面
      path: '/error_view',
      name: 'error_view',
      component: () => import('./views/Error.vue')
    },
    {
      // 環境設定画面
      path: '/preferences',
      name: 'preferences',
      component: () => import('./views/Preferences.vue')
    },
    {
      // 登録モード設定画面{ "新規登録" , "既存カード移行" }
      path: '/regist_selecter',
      name: 'regist_selecter',
      component: () => import('./views/RegistSelecter.vue')
    },
    {
      // プッシュメッセージ一覧表示画面
      path: '/pm_list',
      name: 'pm_list',
      component: () => import('./views/PMList.vue')
    },
    {
      // プッシュメッセージ詳細表示画面
      path: '/pm_detail',
      name: 'pm_detail',
      component: () => import('./views/PMDetail.vue')
    }
  ]
})
